import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ArrowRight, Filter, Search } from "react-feather";
import { Link } from "react-router-dom";
import React from "react";
import styles from "./Filter.module.css";

const Filters = ({ setFilterData, filterData }) => {
  const [filterOpen, setFilterOpen] = React.useState(false);

  const FilterOpenFunction = () => {
    setFilterOpen(true);
  };
  const FilterCloseFunction = () => {
    setFilterOpen(false);
  };

  return (
    <div className={`${styles.SearchFilterSec}`}>
      <div className={`${styles.SearchCon}`}>
        <div className={`${styles.SearchConSec}`}>
          <Search />
          <input
            type="text"
            placeholder="Search"
            onChange={(e) =>
              setFilterData((prev) => {
                return { ...prev, searchKey: e.target.value };
              })
            }
          />
        </div>
      </div>

      <div className={`${styles.FilterSec}`}>
        <div
          className={
            filterOpen === true
              ? `${styles.FilterFieldSec} ${styles.Open}`
              : `${styles.FilterFieldSec}`
          }
        >
          <p className={`${styles.FilterTitle}`}>
            Filters
            <span onClick={FilterCloseFunction}>
              <ArrowRight />
            </span>
          </p>
          <div
            className={`${styles.FilterCard} ${styles.Select} ${styles.Width130} CusSelectFilter Filter`}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                value={filterData?.status}
                onChange={(e) => {
                  setFilterData((prev) => {
                    return {
                      ...prev,
                      status: e.target.value,
                    };
                  });
                }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="0">Open</MenuItem>
                <MenuItem value="1">Assigned</MenuItem>
                <MenuItem value="2">Scheduled</MenuItem>
                <MenuItem value="3">Resolved</MenuItem>
                <MenuItem value="4">Hold</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div
            className={`${styles.FilterCard} ${styles.Select} ${styles.Width130} CusSelectFilter Filter`}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Priority</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Priority"
                value={filterData?.priority}
                onChange={(e) => {
                  setFilterData((prev) => {
                    return {
                      ...prev,
                      priority: e.target.value,
                    };
                  });
                }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="1">Low</MenuItem>
                <MenuItem value="2">Medium</MenuItem>
                <MenuItem value="3">High</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div
            className={`${styles.FilterCard} ${styles.Select} ${styles.Width180} CusSelectFilter Filter`}
          >
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Assignee</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Assignee"
                value={filterData?.assignee}
                onChange={(e) => {
                  setFilterData((prev) => {
                    return {
                      ...prev,
                      assignee: e.target.value,
                    };
                  });
                }}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="assigned-to-me">Assigned to me</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
        <Link className={`${styles.FilterBu}`} onClick={FilterOpenFunction}>
          <Filter />
        </Link>
      </div>
    </div>
  );
};
export default Filters;
